import { defer } from 'react-router-dom'

import { isAppStateReady } from '$appStore'

/**
 * Gate for the Subscription (Manage Payment Details) page to make sure that
 * the app context is ready before we start rendering components that depend on
 * data held within that.
 */
export default async function loader() {
  await isAppStateReady()

  return defer({ data: Promise.resolve(true) })
}
